import React from "react";
import { Box, Typography, Stack, Link } from "@mui/material";
import NewColors from "../../themes/NewColors";
import { ReportStates } from "../../hooks/useReportHistory";
import EmptyStateCard from "../EmptyStateCard";
import ReportOnboardingFlowDialog from "../ReportOnboardingFlowDialog";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import useEvents from "../../hooks/useEvents";

function NoReportsView({ state = ReportStates.unprocessed }) {
  const events = useEvents();
  const [flowDialogOpen, setFlowDialogOpen] = React.useState(false);

  return (
    <Box data-testid="NoReportsView" style={{ margin: 24 }}>
      <EmptyStateCard
        text={
          state === ReportStates.unprocessed
            ? "Nice work. Everything in your review queue is completed."
            : "No previous reports found for this filter."
        }
        background={
          state === ReportStates.unprocessed
            ? NewColors.getTriadicGradient("to right")
            : NewColors.status.error
        }
        borderRadius={24}
      />
      <Box
        style={{
          marginTop: 24,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack style={{ maxWidth: 500 }} spacing={2}>
          <Typography style={{ textAlign: "center" }}>
            {state === ReportStates.unprocessed
              ? "New weekly reports will appear here when clients submit them."
              : "Try expanding the date range or turning off filters to load more report history."}
          </Typography>
          
          {/* Only show the flow link when unprocessed reports are empty */}
          {state === ReportStates.unprocessed && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 0.5,
                mt: 1,
              }}
            >
              <InfoOutlinedIcon sx={{ fontSize: 16, color: "text.secondary" }} />
              <Link
                component="button"
                variant="body2"
                onClick={() => {
                  setFlowDialogOpen(true);
                  events.logButtonClick({
                    buttonName: "View Report Process Flow",
                    pageName: "Reports",
                    tabName: "Empty",
                  });
                }}
                sx={{
                  cursor: "pointer",
                  textDecoration: "none",
                  color: "text.secondary",
                  fontSize: "0.875rem",
                  "&:hover": {
                    textDecoration: "underline",
                    color: "primary.main",
                  },
                }}
              >
                How does the report process work?
              </Link>
            </Box>
          )}

        </Stack>
      </Box>
      <ReportOnboardingFlowDialog
        open={flowDialogOpen}
        onClose={() => setFlowDialogOpen(false)}
      />
    </Box>
  );
}

export default NoReportsView;
